import { useState, useCallback } from 'react';
import { useTutorial } from '../TutorialContext';

export const useSaveSuccess = (stepId, duration = 2000) => {
  const [showSuccess, setShowSuccess] = useState(false);
  const { markStepComplete } = useTutorial();

  const triggerSuccess = useCallback(() => {
    setShowSuccess(true);
    if (stepId) {
      markStepComplete(stepId);
    }
    setTimeout(() => {
      setShowSuccess(false);
    }, duration);
  }, [duration, stepId, markStepComplete]);

  return [showSuccess, triggerSuccess];
}; 